/**
 * APIMATIC CalculatorLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { Schema, stringEnum } from '../schema';

/**
 * Enum for OperationTypeEnum
 */
export enum OperationTypeEnum {
  SUM = 'SUM',
  SUBTRACT = 'SUBTRACT',
  MULTIPLY = 'MULTIPLY',
  DIVIDE = 'DIVIDE',
}

/**
 * Schema for OperationTypeEnum
 */
export const operationTypeEnumSchema: Schema<OperationTypeEnum> = stringEnum(OperationTypeEnum);
